import { styled } from 'styled-components';

export const NoResults = styled.p`
  margin: 0;
  padding: 0;
  margin-top: ${({ theme }) => theme.spacing(1)}px;
`;
